import { service } from '@maia/quotation';
import { useMutation } from '@tanstack/react-query';

type Params = Parameters<typeof service.cancel>[0];

export function useCancel(
  onSuccess: (data: unknown) => void,
  onError: () => void,
) {
  return useMutation({
    mutationFn: (params: Params) => service.cancel(params),
    onSuccess,
    onError,
  });
}
